export const widgets = {
    dashboardOperation:true,
    caixaOnline:true,
    shortCut:true ,
    statusCotasFirstScreen:true,
    statusCotasSecondScreen:true,//yasser should be false in prod env
    insumosPendentesFirstScreen:true,
    insumosPendentesSecondScreen:true,
    PandL:true,
    acumuladoGestao:true,
    ativoMenu:true, //yasser should be false in prod env
    passiveMenu:true,//yasser should be false in prod env
    SantanderOper:true,//yasser should be false in prod env
    cutofftimescreen :true,//yasser should be false in prod env
    exceptioncutofftimescreen:true,//yasser should be false in prod env
    foreyestab:true,//yasser should be false in prod env
    LOGs:true,//yasser should be false in prod env
    parametros:true ,//yasser should be false in prod env
    cotas : true ,//when it will  in MenuFundosComponent change cotas to 3 and infoFundos to 4 (line248)
    //don't change it
}